<script>
import navigation from "./components/layout/navigation.vue";
import customMessage from "./components/layout/customMessage.vue";
import loadingWheel from "./components/common/loadingWheel.vue";

export default {
  name: "App",
  components: { navigation, customMessage, loadingWheel },
  methods: {},
  computed: {
    isAuthorised() {
      return this.$store.state.isAuthorised;
    },
    showLoader: function() {
      return this.$store.state.showLoader;
    },
  },
  async mounted() {},
  watch: {},
};
</script>
<template>
  <v-app>
    <custom-message></custom-message>
    <navigation app v-if="isAuthorised"></navigation>
    <v-main>
      <v-container fluid :fill-height="!isAuthorised" :class="[isAuthorised ? '' : 'login-bg']">
        <keep-alive>
          <router-view :key="$route.fullPath" />
        </keep-alive>
      </v-container>
    </v-main>
    <loading-wheel v-if="showLoader"></loading-wheel>
  </v-app>
</template>

<style></style>
